'use strict';
import {stateGo} from 'redux-ui-router';
import {Observable} from 'rxjs/Observable';
import {getOrganization} from '../../app/model/reducers/state';
import {SCOPE_DESTROY} from '../../config/constants/view-events';
import {PLACEHOLDER} from '../../core-components/loading-icon/loading-states';
import {getCollection, getDomainClass, getId} from '../../core-utilities/domain/ReduxUtils';
import {eventToObservable} from '../../core-utilities/rx-utils';
import {logger} from './logger';


const angular = require('angular');
const {forEach} = angular;


DataTagsManageTaggedController.$inject = [
  '$scope',
  '$ngRedux',
  '$stateParams',
  '$toast',
  '$miscUtils',
  '$exceptionHandler',
  '$contextMenu',
  '$ionicViewSwitcher',
  'OrganizationDomain',
  'DataTagDomain',
  'DataTagsManageTaggedFilter',
  'DataTagsService',
  'FirebaseConnectionService',
  'taggable',
  'sourceName',
  'manageName',
];

// TODO: add appliesTo filter
// TODO: change end condition handling on adding/removing to occur as dataTags are added/removed using the collection watcher rather than the promise fulfillment
// requires taggable id and collection to resolve the instance before this controller loads
export function DataTagsManageTaggedController(
  $scope,
  $ngRedux,
  $stateParams,
  $toast,
  $miscUtils,
  $exceptionHandler,
  $contextMenu,
  $ionicViewSwitcher,
  OrganizationDomain,
  DataTagDomain,
  DataTagsManageTaggedFilter,
  DataTagsService,
  FirebaseConnectionService,
  taggable,
  sourceName,
  manageName,
) {

  // handle failed taggable retrieval
  if (!taggable) {
    $toast.showI18nMessage({
      messageId: 'data.tags.errors.failed.to.load.message',
      type: 'error',
    });
    return goBack();
  }

  const vm = $scope.manageDataTags = {};
  const filterService = DataTagsManageTaggedFilter(vm, $scope);
  const selectDataTagObservable = $scope.$createObservableFunction('toggleSelect');
  const selectedDataTags = {};
  const dataTagsInProgress = {};
  const dataTagsWithErrors = {};
  const selectedDataTagsToAdd = {};
  const selectedDataTagsToRemove = {};
  const expectedMembers = {};

  /* Header Actions */
  vm.goBack = goBack;
  vm.save = $miscUtils.blockPromise(save);
  vm.openContext = showMenu;

  /* Controller Actions */
  vm.create = createTag;
  vm.manageTags = manageTags;

  /* Presentation Logic */
  vm.getItemClass = getItemClass;
  vm.getButtonIcon = getButtonIcon;
  vm.getProgressIcon = getProgressIcon;
  vm.showPlaceholder = showPlaceholder;

  vm.dataTagEditor = {};

  /* Presentation Logic */
  vm.hasTags = true;

  $miscUtils.bindToExit($scope, isDirty);

  // TODO(redux-domain): Convert and also re-implement to remove nested stream subscriptions if feasible
  $ngRedux.state$
    .map(getOrganization)
    .takeUntil(eventToObservable($scope, SCOPE_DESTROY)) // this is probably overkill
    .filter(organization => !!organization)
    .take(1) // Ensures we only get 1 occurrence
    .subscribe(organization => {
      const dataTagList = OrganizationDomain.$getDataTagsList(getId(organization));
      const domainClass = getDomainClass(getCollection(taggable));
      const tagLinkList = domainClass.$getDataTagsList(getId(taggable));

      const observables = filterService.initFiltering(dataTagList, tagLinkList, getCollection(taggable));
      watchTagLinks(observables);
    });


  /*****************************************************************************************************************
   * Header Buttons
   ****************************************************************************************************************/

  function goBack() {
    $ionicViewSwitcher.nextDirection('back');
    $ngRedux.dispatch(stateGo(sourceName));
  }


  /*****************************************************************************************************************
   * Context Menu Actions
   ****************************************************************************************************************/

  const MANAGE_DATA_TAGS = {
    permission: 'organization_data-tags_edit',
    action: {messageId: 'data.tags.manage.context.manage.label', action: manageTags},
  };

  function showMenu() {
    const orgId = getId(getOrganization($ngRedux.getState()));
    if (!orgId) return;

    const checkActions = [];
    $contextMenu.addActionByOrg(checkActions, orgId, MANAGE_DATA_TAGS);

    $contextMenu.showByPermission({
      titleMessageId: 'data.tags.manage.context.title.label',
      cancelMessageId: 'defaults.context.cancel.label',
      actions: checkActions,
    });
  }


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  function createTag() {
    return DataTagsService.createOrUpdateDataTag(null);
  }

  function manageTags() {
    $ionicViewSwitcher.nextDirection('forward');
    $ngRedux.dispatch(stateGo(manageName, $stateParams));
  }

  function addToDataTags(tagLinkFilter, dataTag) {
    const dataTagId = getId(dataTag);
    if (!dataTagId || dataTagsInProgress[dataTagId]) return;
    if (selectedDataTags[dataTagId]) {
      delete selectedDataTags[dataTagId];

      if (tagLinkFilter[dataTagId]) {
        delete selectedDataTagsToRemove[dataTagId];
      } else {
        delete selectedDataTagsToAdd[dataTagId];
      }
    } else {
      selectedDataTags[dataTagId] = true;

      if (tagLinkFilter[dataTagId]) {
        selectedDataTagsToRemove[dataTagId] = true;
      } else {
        selectedDataTagsToAdd[dataTagId] = true;
      }
    }
  }

  function isDirty() {
    if (!taggable) {
      return false;
    } else {
      const result = buildInProgress();
      return result.totalChange > 0;
    }
  }

  function save() {
    if (!taggable)
      return $toast.showMessage('An Error Occurred!', null, 'error');// TODO(i18n): convert to message code

    if (!FirebaseConnectionService.online)
      return Promise.reject({code: 'default.error.offline.message'});

    const editResults = buildInProgress();
    if (editResults.totalChange === 0)
      return $toast.showMessage('You must select a tag first!', null, 'error');// TODO(i18n): convert to message code

    const promises = [];
    const adding = editResults.adding;
    const removing = editResults.removing;

    for (const dataTagId in editResults.inProgress) {
      if (editResults.inProgress.hasOwnProperty(dataTagId))
        dataTagsInProgress[dataTagId] = true;
    }

    if (adding.length)
      promises.push(DataTagDomain.tagInstance(taggable, adding).catch(handleSaveError(adding, true)));
    if (removing.length)
      promises.push(DataTagDomain.unTagInstance(taggable, removing).catch(handleSaveError(removing, false)));

    return Promise.all(promises)
      .then(function () {
        // TODO(i18n): convert to message code and pluralize
        // TODO: consider reporting the list of dataTags in each category?
        if (adding.length > 0)
          $toast.showMessage(adding.length === 1 ? 'Tag Added!' : 'Tags Added!', null, 'info');
        if (removing.length > 0)
          $toast.showMessage(removing.length === 1 ? 'Tag Removed!' : 'Tags Removed!', null, 'info');
      })
      .catch(function (err) {
        logger.error({err});
      });// TODO: show errors in view
  }

  function buildInProgress() {
    const adding = [];
    const removing = [];
    const inProgress = {};
    let totalChange = 0;

    for (const dataTagId in selectedDataTags) {
      if (selectedDataTags.hasOwnProperty(dataTagId) && !dataTagsInProgress[dataTagId]) {
        inProgress[dataTagId] = true;
        totalChange++;
        if (selectedDataTagsToRemove[dataTagId]) {
          removing.push(dataTagId);
        } else {
          adding.push(dataTagId);
        }
      }
    }

    return {
      adding: adding,
      removing: removing,
      inProgress: inProgress,
      totalChange: totalChange,
    };
  }

  function handleSaveError(dataTags, adding) {
    const prefix = `Failed to ${adding ? 'add' : 'remove'} dataTag `;
    const postfix = `${adding ? ' to' : ' from'} taggable ${getId(taggable)}`;
    return function (error) {
      forEach(dataTags, function (dataTagId) {
        delete dataTagsInProgress[dataTagId];
        delete selectedDataTags[dataTagId];
        dataTagsWithErrors[dataTagId] = true;
        $exceptionHandler(error, prefix + dataTagId + postfix);
      });
    };
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

  function showPlaceholder() {
    return vm.loadingMode === PLACEHOLDER;
  }

  function watchTagLinks(filterObservables) {
    filterService.addSubscription(Observable.combineLatest(
      filterObservables.getTagLinksFilter$(),
      selectDataTagObservable.startWith(null),
      (tagLinksFilter, dataTag) => {
        addToDataTags(tagLinksFilter, dataTag);
        return tagLinksFilter;
      })
      .subscribe(results => {
        $scope.$evalAsync(buildExpectedMembers.bind(null, results));
      })
    );
  }

  function buildExpectedMembers(dataTagsInProject) {
    // Update in progress states
    for (const idInProgress in dataTagsInProgress) {
      if (dataTagsInProgress.hasOwnProperty(idInProgress)) {
        if (selectedDataTagsToRemove[idInProgress] && !dataTagsInProject[idInProgress]) {
          delete expectedMembers[idInProgress];
          delete selectedDataTags[idInProgress];
          delete dataTagsInProgress[idInProgress];
          delete selectedDataTagsToRemove[idInProgress];

        } else if (selectedDataTagsToAdd[idInProgress] && dataTagsInProject[idInProgress]) {
          delete expectedMembers[idInProgress];
          delete selectedDataTags[idInProgress];
          delete dataTagsInProgress[idInProgress];
          delete selectedDataTagsToAdd[idInProgress];
        }
      }
    }

    // Determine new membership
    for (const dataTagId in dataTagsInProject) {
      if (dataTagsInProject.hasOwnProperty(dataTagId)) {
        if (!selectedDataTags[dataTagId]) {
          expectedMembers[dataTagId] = true;
        } else {
          delete expectedMembers[dataTagId];
        }
      }
    }

    for (const selectedId in selectedDataTags) {
      if (selectedDataTags.hasOwnProperty(selectedId) && !dataTagsInProject[selectedId]) {
        expectedMembers[selectedId] = true;
      }
    }

    for (const expectedId in expectedMembers) {
      if (expectedMembers.hasOwnProperty(expectedId)
        && !selectedDataTags.hasOwnProperty(expectedId)
        && !dataTagsInProject.hasOwnProperty(expectedId)) {

        delete expectedMembers[expectedId];
      }
    }

    // console.log('current members')
    // console.log(dataTagsInProject)
    //
    // console.log('expected members')
    // console.log(expectedMembers)
    //
    // console.log('selectedDataTags')
    // console.log(selectedDataTags)
    //
    // console.log('removing')
    // console.log(selectedDataTagsToRemove)
    //
    // console.log('adding')
    // console.log(selectedDataTagsToAdd)
  }

  function getItemClass(tag) {
    return (expectedMembers[getId(tag)] ? 'asset-in-project' : '') + (tag.description ? ' item-with-description' : '');
  }

  function getButtonIcon(id) {
    if (dataTagsWithErrors[id])
      return 'ion-alert';
    else
      return expectedMembers[id] ? 'x-rotate ion-ios-plus-empty' : 'ion-ios-plus-empty';
  }

  function getProgressIcon(id) {
    if (!dataTagsInProgress[id])
      return null;
    else
      return expectedMembers[id] ? 'progress-asset-in-project' : 'progress-asset-not-in-project';
  }
}



// WEBPACK FOOTER //
// ./src/js/data-tags/controllers/DataTagsManageTaggedController.js